import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Messages } from 'src/app/constants/messages';
import { NotificationMessageComponent } from 'src/app/dialogs/notification-message/notification-message.component';
import { TypeIcon } from 'src/app/model/device/message.model';
import { CallPlace } from 'src/app/model/http/myActivity.model';
import { IMyProfile, UpdatePhotoInfo } from 'src/app/model/http/profile.model';
import {
  FileSelectedResult,
  UpdatePhotoValidators,
  UpdateProfilePhoto
} from 'src/app/model/local/general.model';
import { PromotionPhotoProfile, ReportPhotoProfile } from 'src/app/model/local/report.photo.profile';
import { SaveAdviserProfilePhoto } from 'src/app/model/local/saveAdviserPhoto';
import { CommonService } from 'src/app/services/common.service';
import { DialogService } from 'src/app/services/dialog.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObservableService } from 'src/app/services/observable.service';
import {
  Actions,
  BooleanCons,
  MessageType,
  RolesString,
  StringConst
} from '../../constants/const';
import { IGeneralResponse } from '../../model/http/general-response.model';
import { AdvisorInformationService } from '../../services/advisor-information.service';
import { MyProfileService } from '../../services/my-profile.service';

@Component({
  selector: 'app-update-photo',
  templateUrl: './update-photo.component.html',
  styleUrls: ['./update-photo.component.scss'],
})
export class UpdatePhotoComponent implements OnInit {
  existProfilePhoto = false;
  myHeaderProfile = new IMyProfile();
  profilePhoto = StringConst.empty;
  cardCode = StringConst.empty;
  isChangePhoto = false;
  coverImage = BooleanCons.false;
  rol = StringConst.empty;
  constructor(
    private dialogRef: MatDialogRef<UpdatePhotoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdatePhotoInfo,
    private profileService: MyProfileService,
    private advisorInformationService: AdvisorInformationService,
    private commonService: CommonService,
    private observableService: ObservableService,
    private localStorageService: LocalStorageService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.cardCode = this.data.cardCode;
    this.isChangePhoto = this.data.changePhoto;
    this.existProfilePhoto = this.data.existProfilePhoto;
    this.myHeaderProfile = this.data.myHeaderProfile;
    this.profilePhoto = this.data.profilePhoto;
    this.coverImage = this.data.coverImage ?? BooleanCons.false;
  }

  changeProfilePhoto(fileSelected: FileSelectedResult): void {
    const type = fileSelected.type;
    const photo = fileSelected.base64;
    if (photo !== undefined) {
      const rol = this.localStorageService.getUserInRole();
      const validateLoggedList = [
        {
          place: [CallPlace.components, CallPlace.myProfile],
          rol: RolesString.advisor,
          flag: false,
          changeForAdvisor: true,
          changeForDoctor: false,
          changeForReporter: false,
        },
        {
          place: [CallPlace.components, CallPlace.myProfile],
          rol: RolesString.advisor,
          flag: true,
          changeForAdvisor: false,
          changeForDoctor: true,
          changeForReporter: false,
        },
        {
          place: [this.data.callPlace],
          rol: RolesString.doctor,
          flag: this.data.isDoctorSelected,
          changeForAdvisor: false,
          changeForDoctor: true,
          changeForReporter: false,
        },
        {
          place: [CallPlace.components],
          rol: RolesString.reporter,
          flag: this.data.isDoctorSelected,
          changeForAdvisor: false,
          changeForDoctor: false,
          changeForReporter: true,
        },
        {
          place: [CallPlace.components],
          rol: RolesString.adminPromo,
          flag: this.data.isDoctorSelected,
          changeForAdvisor: false,
          changeForDoctor: false,
          changeForReporter: false,
        },
      ];
      const validator = new UpdatePhotoValidators();
      validator.rol = rol;
      validator.flag = this.data.isDoctorSelected;
      const selectedData = this.validate(validateLoggedList, validator)[0];

      if (selectedData.changeForDoctor) {
        this.changeDoctorPhoto(fileSelected, type, photo);
      }
      if (selectedData.changeForAdvisor) {
        this.changeAdviserPhoto(fileSelected, type, photo);
      }
      if (selectedData.changeForReporter) {
        this.changeReporterPhoto(fileSelected, type, photo);
      }
      if (selectedData.rol === RolesString.adminPromo) {
        this.changePromoAdminPhoto(fileSelected, type, photo);
      }
    }
  }

  validate(
    list: UpdatePhotoValidators[],
    validateData: UpdatePhotoValidators
  ): UpdatePhotoValidators[] {
    return (
      list.filter(
        (data) =>
          data.place.includes(this.data.callPlace) &&
          data.rol === validateData.rol &&
          data.flag === validateData.flag
      ) ?? [new UpdatePhotoValidators()]
    );
  }
  updatePhotoLocally(fileSelected: FileSelectedResult): void {
    this.existProfilePhoto = true;
    this.profilePhoto = this.commonService.convertStringToBase64(
      fileSelected.base64 ?? StringConst.empty,
      fileSelected.type
    );
    const rol = this.localStorageService.getUserInRole();
    const validateLoggedList = [
      {
        place: [CallPlace.components, CallPlace.myProfile],
        rol: RolesString.advisor,
        flag: true,
        changeForAdvisor: false,
        changeForDoctor: true,
        changeForReporter: false,
      },
      {
        place: [this.data.callPlace],
        rol: RolesString.doctor,
        flag: this.data.changeBoth,
        changeForAdvisor: false,
        changeForDoctor: true,
        changeForReporter: false,
      },
      {
        place: [CallPlace.myProfile],
        rol: RolesString.advisor,
        flag: this.data.changeBoth,
        changeForAdvisor: true,
        changeForDoctor: false,
        changeForReporter: false,
      },
      {
        place: [CallPlace.components],
        rol: RolesString.advisor,
        flag: this.data.changeBoth,
        changeForAdvisor: false,
        changeForDoctor: false,
        changeForReporter: true,
      },
      {
        place: [CallPlace.components],
        rol: RolesString.reporter,
        flag: this.data.changeBoth,
        changeForAdvisor: false,
        changeForDoctor: false,
        changeForReporter: true,
      },
      {
        place: [CallPlace.components],
        rol: RolesString.adminPromo,
        flag: this.data.changeBoth,
        changeForAdvisor: false,
        changeForDoctor: false,
        changeForReporter: false,
      },
    ];
    const validator = new UpdatePhotoValidators();
    validator.rol = rol;
    validator.flag = this.data.changeBoth;
    const selectedData = this.validate(validateLoggedList, validator);
    selectedData.forEach((data) => {
      if (data.changeForDoctor) {
        this.observableService.setUpdateMenuPhoto(fileSelected);
      }
      if (data.changeForAdvisor) {
        this.observableService.setUpdateOnlyProfilePhoto(fileSelected);
      }
      if (data.changeForReporter) {
        this.observableService.setUpdateOnlyMenuProfilePhoto(fileSelected);
      }
      if (data.rol === RolesString.adminPromo) {
        this.observableService.setUpdateOnlyMenuProfilePhoto(fileSelected);
      }
    });
    this.launchConfirmationMessage();
    this.dialogRef.close();
  }

  changeDoctorPhoto(
    fileSelected: FileSelectedResult,
    type: string,
    photo: string
  ): void {
    const updateProfilePhoto = new UpdateProfilePhoto();
    updateProfilePhoto.doctorId = this.cardCode;
    updateProfilePhoto.profilePicture = photo;
    updateProfilePhoto.pictureFormat = type;
    this.profileService
      .updateProfilePhoto(updateProfilePhoto)
      .subscribe(
        (res) => {
          res.code !== 200
            ? this.launchControlledError(res.userError)
            : this.updatePhotoLocally(fileSelected);
        });
  }

  changeAdviserPhoto(
    fileSelected: FileSelectedResult,
    type: string,
    photo: string
  ): void {
    const adviserPhoto = new SaveAdviserProfilePhoto();
    adviserPhoto.cardCode = this.commonService.getUserInfo().advisorId;
    adviserPhoto.profilePicture = photo;
    adviserPhoto.pictureFormat = type;
    this.advisorInformationService
      .updateProfilePhotoAdviser(adviserPhoto)
      .subscribe(
        (res) => this.doProcessWhenPhotoIsUpdated(res, fileSelected)
      );
  }
  doProcessWhenPhotoIsUpdated(
    res: IGeneralResponse,
    fileSelected: FileSelectedResult
  ): void {
    res.code !== 200
      ? this.launchControlledError(res.userError)
      : this.successPhotoUpdate(fileSelected);
  }

  successPhotoUpdate(fileSelected: FileSelectedResult): void {
    this.updatePhotoLocally(fileSelected);
    this.updateAdviserInfoSap();
  }

  changeReporterPhoto(
    fileSelected: FileSelectedResult,
    type: string,
    photo: string
  ): void {
    const reporterPhoto = new ReportPhotoProfile();
    reporterPhoto.reportUserName = this.commonService.getUserInfo().email;
    reporterPhoto.pictureFormat = type;
    reporterPhoto.profilePicture = photo;
    this.profileService.saveReporterPhotoProfile(reporterPhoto).subscribe(
      (res) => this.doProcessWhenPhotoIsUpdated(res, fileSelected)
    );
  }

  changePromoAdminPhoto(
    fileSelected: FileSelectedResult,
    type: string,
    photo: string
  ): void {
    const req = new PromotionPhotoProfile();
    req.adminUserName = this.commonService.getUserInfo().email;
    req.pictureFormat = type;
    req.profilePicture = photo;
    this.profileService.changePromoProfilePhoto(req).subscribe(
      (res) => {
        res.code !== 200 ? this.launchControlledError(res.userError) :
          this.updatePhotoLocally(fileSelected);
      }
    );
  }

  updateAdviserInfoSap(): void {
    this.advisorInformationService.getAdvisorInfoFromSAP().subscribe(
      (res) => {
        const result = res.response ?? [];
        if (result.length > 0) {
          const advisorInfo = result[0];
          this.localStorageService.setAdvisorInformationFromSAP(advisorInfo);
        }
      });
  }

  launchControlledError(message?: string): void {
    const text = this.commonService.calculateTernary(
      message !== undefined,
      message,
      Messages.generic
    );
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      typeIcon: TypeIcon.error,
      textToShow: text,
      isButtonCancel: false,
      typeMessage: MessageType.none,
    });
  }

  launchConfirmationMessage(): void {
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      typeIcon: TypeIcon.success,
      textToShow: Messages.updateProfilePhoto,
      isButtonCancel: false,
      typeMessage: MessageType.none,
    });
  }
}
